<div class="d-flex flex-column flex-column-fluid h-100 dashboard-root">
  <div
    id="kt_app_content"
    class="app-content flex-column-fluid h-100 d-flex flex-column"
  >
    <div
      id="kt_app_content_container"
      class="app-container container-fluid d-flex flex-column flex-grow-1 dashboard-page-container"
      style="min-height: 0"
    >
      <!-- Dashboard Header -->
      <div class="row g-3 mb-4">
        <div
          *ngFor="let item of dashboardHeaderItems"
          class="col-md-3 col-sm-6 col-12 mb-md-0 mb-4"
        >
          <div class="card card-xl-stretch h-100 dashboard-header-card">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-2">
                <h1 class="dashboard-stat-value fw-bold flex-grow-1 mb-0">
                  <span *ngIf="item.label === 'totalIncome'">
                    <i class="fa-solid fa-euro-sign dashboard-stat-value"></i>
                  </span>

                  <!-- SAYI BURADAN -->
                  {{ dashboardStatistics[item.countKey] || 0 }}
                </h1>

                <div class="symbol">
                  <span class="symbol-label bg-white">
                    <img
                      [src]="item.icon"
                      class="img-fluid"
                      [alt]="item.label"
                    />
                  </span>
                </div>
              </div>

              <div class="dashboard-stat-label fw-bold fs-4 mb-2">
                {{ item.label | translate }}
              </div>

              <p class="mt-auto fs-14 increase-text mb-0">
                <i
                  class="fa-solid fs-6 me-2"
                  [ngClass]="getArrowStyle(item.increasePercentageLastMonth)"
                ></i>
                {{ item.increasePercentageLastMonth.toFixed(1) }}%
                {{ "thisMonth" | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Charts and Statistics (this row stretches to fill remaining height) -->
      <div class="row g-4 charts-row flex-grow-1" style="min-height: 0">
        <!-- Line Chart (left) -->
        <div class="col-md-8 col-12 d-flex flex-column">
          <div class="card h-100 d-flex flex-column">
            <div class="card-body d-flex flex-column flex-grow-1 p-3">
              <div
                class="d-flex align-items-center justify-content-between"
                style="padding: 1.25rem"
              >
                <h4 class="card-title mb-4">
                  {{ "dashboard.patientsAndScans" | translate }}
                </h4>
                <div class="form-floating">
                  <select
                    [(ngModel)]="selectedChartType"
                    (change)="onChangeChart($event)"
                    class="form-select cursor-pointer"
                    id="inputSelect"
                    aria-label="Select"
                  >
                    <option
                      *ngFor="let item of chartSelectionType"
                      [value]="item.value"
                    >
                      {{ item.label | translate }}
                    </option>
                  </select>
                  <label for="inputSelect">{{
                    "dashboard.selectComboTitle" | translate
                  }}</label>
                </div>
              </div>

              <!-- canvas area fills the remaining height -->
              <!-- <div class="chart-container flex-grow-1 d-flex" style="min-height: 200px;">
                <canvas id="lineChart" class="flex-fill"></canvas>
              </div> -->
              <div
                class="chart-container flex-grow-1"
                style="min-height: 200px"
              >
                <apx-chart
                  *ngIf="apxOptions"
                  [series]="apxOptions.series!"
                  [chart]="apxOptions.chart!"
                  [xaxis]="apxOptions.xaxis!"
                  [stroke]="apxOptions.stroke!"
                  [dataLabels]="apxOptions.dataLabels!"
                  [grid]="apxOptions.grid!"
                  [tooltip]="apxOptions.tooltip!"
                  [legend]="apxOptions.legend!"
                  [markers]="apxOptions.markers!"
                  [yaxis]="apxOptions.yaxis!"
                  [plotOptions]="apxOptions.plotOptions!"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>

        <!-- Statistics (right) -->
        <div class="col-md-4 col-12 d-flex flex-column">
          <div
            class="d-flex flex-column flex-grow-1 gap-4"
            style="min-height: 0"
          >
            <!-- After 2 weeks -->
            <div class="card flex-fill d-flex">
              <div class="card-body d-flex flex-column justify-content-between">
                <div>
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountByTwoWeeks ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor2weeks" | translate }}
                  </p>
                </div>
                <div class="mt-2">
                  <div class="progress">
                    <div
                      class="progress-bar dashboard-progress-weak"
                      role="progressbar"
                      style="width: 25%"
                      aria-valuenow="25"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- After 1 month -->
            <div class="card flex-fill d-flex">
              <div class="card-body d-flex flex-column justify-content-between">
                <div>
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountByOneMonth ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor1month" | translate }}
                  </p>
                </div>
                <div class="mt-2">
                  <div class="progress">
                    <div
                      class="progress-bar dashboard-progress-brand"
                      role="progressbar"
                      style="width: 50%"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- After 2 months -->
            <div class="card flex-fill d-flex">
              <div class="card-body d-flex flex-column justify-content-between">
                <div>
                  <h1 class="mb-0">
                    {{
                      dashboardStatistics?.totalFollowUpPatientCountByTwoMonths ||
                        0
                    }}
                  </h1>
                  <p class="fs-14 fw-bold">
                    {{ "dashboard.statisticsFor2months" | translate }}
                  </p>
                </div>
                <div class="mt-2">
                  <div class="progress">
                    <div
                      class="progress-bar dashboard-progress-strong"
                      role="progressbar"
                      style="width: 100%"
                      aria-valuenow="100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Support Center and Images -->
      <div class="row g-4 mt-0 d-flex align-items-stretch">
        <!-- Support Center -->
        <div class="col-md-8 col-12 d-flex flex-column">
          <div class="card support-card h-100">
            <div class="card-body d-flex flex-column justify-content-center">
              <h2 class="card-title mb-3">
                {{ "dashboard.supportCenter" | translate }}
              </h2>
              <p class="card-text fs-14 mt-4">
                {{ "dashboard.supportCenterDesc" | translate }}
              </p>
              <p class="fw-bold fs-14 mt-auto">
                {{ "dashboard.supportCenterCall" | translate }}
              </p>
            </div>
          </div>
        </div>
        <!-- Images -->
        <div class="col-md-4 col-12 d-flex flex-column">
          <div class="row g-4 flex-grow-1">
            <div class="col-6 d-flex flex-column">
              <img
                src="assets/images/Dashboard-Image1.jpg"
                alt="Image 1"
                class="dashboard-image"
              />
            </div>
            <div class="col-6 d-flex flex-column">
              <img
                src="assets/images/Dashboard-Image2.png"
                alt="Image 2"
                class="dashboard-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
